import pt from './pt.json'
import en from './en.json'
import CONSTANTS from '@/utils/config'

export const i18n = new VueI18n({
  locale: CONSTANTS.LANGUAGE.toLowerCase() || 'pt',
  fallbackLocale: 'en',
  messages: {
    en,
    pt
  }
})